import React, { useEffect } from "react";
import PropTypes from "prop-types";
/* Components */
import { Route, Routes } from "react-router-dom";
import HorizontalLayout from "./components/HorizontalLayout/";
/* Redux */
import { connect, useDispatch } from "react-redux";
import { userRoutes } from "@/routes/allRoutes";
/* Helpers and Selectors */
import { api, chain, ethereum } from "@/config";
/* Google analytics */
import ReactGA from "react-ga4";
/* Style */
import "./assets/scss/theme.scss";

initializeReactGA();

const App = (props) => {
  let dispatch = useDispatch();
  const Layout = HorizontalLayout;

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch({ type: "ETH_DISPATCH_CLOCK" });
    }, ethereum.clock);
    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch({ type: "API_DISPATCH_CLOCK" });
    }, api.clock);
    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    dispatch({ type: "SET_ALL_SETTINGS" });
  }, [dispatch]);

  useEffect(() => {
    dispatch({ type: "SET_USER_CURRENT_CHAIN", name: chain.name, id: chain.id, rpc: chain.rpc });
  }, [dispatch]);

  return (
    <React.Fragment>
      <Routes>
        {userRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <Layout>
                <route.component />
              </Layout>
            }
            exact
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

function initializeReactGA() {
  if (import.meta.env.VITE_GA_TRACKING_ID) {
    ReactGA.initialize(import.meta.env.VITE_GA_TRACKING_ID);
    ReactGA.send("pageview");
  }
}

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = (state) => {
  return { layout: state.Layout, userState: state.UserReducer, ethState: state.EthereumReducer };
};

export default connect(mapStateToProps, null)(App);
